import { Controller } from "@hotwired/stimulus";

// Médiateur : synchronise le toggle tax_program avec la fiscalité du payload API.
// Écoute remote:update:success et dispatch toggle:set.
export default class extends Controller {
  connect() {
    this.onUpdate = (e) => this.syncToggle(e);
    this.element.addEventListener("remote:update:success", this.onUpdate);
  }

  disconnect() {
    this.element.removeEventListener("remote:update:success", this.onUpdate);
  }

  syncToggle(event) {
    const value = event?.detail?.payload?.criterias?.tax_program;
    if (!value) return;

    this.element.dispatchEvent(new CustomEvent("toggle:set", {
      bubbles: true,
      detail: { scope: "tax_program", value }
    }));
  }
}
